import classNames from 'classnames'

export default props => {
  const { label, children, block = false } = props

  return (
    <div className={classNames('field-item', { block })}>
      <div className='field-label'>{label}:</div>
      <div className='field-body'>
        {children}
      </div>
    </div>
  )
}
